import dayjs from 'dayjs'

import { ICalendarPriceResponse } from 'shared/api/Calendar'
import { DateInfo } from 'shared/ui/month-wrapper'

export const prepareDate = (date: string) => date?.split('-').join('/')

export const toCalendarDataDate = (date?: string | Date): string => {
  if (!date) return ''

  const parsed =
    typeof date === 'string'
      ? dayjs(date.includes('/') ? date.split('/').join('-') : date)
      : dayjs(date)

  if (!parsed.isValid()) return ''

  const year = parsed.year()
  const month = String(parsed.month() + 1).padStart(2, '0')
  const day = String(parsed.date()).padStart(2, '0')

  return `${year}/${month}/${day}`
}

export const formatDateFetch = (date?: string): string | undefined => {
  if (!date) return undefined

  const [year, month, day] = date.split('/')

  const formattedMonth = month.padStart(2, '0')
  const formattedDay = day.padStart(2, '0')

  return `${year}-${formattedMonth}-${formattedDay}`
}

export const prepareCalendarPrices = (
  calendarPrices?: ICalendarPriceResponse[] | null,
): DateInfo[] | undefined =>
  calendarPrices?.map((day) => ({
    date: prepareDate(String(day.back_date || day.dep_date)),
    content: String(day.price),
    isCheapest: !!day?.is_cheapest,
  }))
